import { apiService } from './ApiService';

export interface ROIMetrics {
    scope?: 'personal' | 'organization'; // Indicates if metrics are personal or org-level
    bottomLine: {
        totalValueGenerated: number;
        roiMultiplier: number;
        paybackDays: number;
        laborSavings: number;
    };
    revenue: {  
        aiUpsellRevenue: number;
        aiUpsellTrend: number;
        topUpsells: Array<{
            item: string;
            count: number;
        }>;
        speedToLeadRevenue: number;
        afterHoursRevenue: number;
        afterHoursOrders: number;
        baselineWinRate: number;
        currentWinRate: number;
    };
    productivity: {
        hoursSaved: number;
        fteEquivalent: number;
        automationRate: number;
        avgResponseSeconds: number;
        industryAvgHours: number;
        totalQuotesProcessed: number;
    };
    quality: {
        errorPreventionSavings: number;
        vinMatchAccuracy: number;
        avgCustomerRating: number;
    };
    recentWins: Array<{
        id: string;
        type: 'upsell' | 'speed' | 'automation' | 'afterhours';
        message: string;
        value?: number;
        timestamp: string;
    }>;
    simulatorDefaults: {
        avgRepairValue: number;
        employeeCostPerHour: number;
        quotesPerDay: number;
    };
}

class DashboardService {
    /**
     * Fetch ROI metrics for the specified time range
     */
    async getROIMetrics(timeRange: 'week' | 'month' | 'quarter'): Promise<ROIMetrics> {
        try {
            const response = await apiService.get('/api/dashboard/roi-metrics', {
                params: { timeRange }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching ROI metrics:', error);
            // Return mock data for development
            return null as unknown as ROIMetrics;
        }
    }

    /**
     * Download CFO Report PDF
     */
    async downloadCFOReport(): Promise<void> {
        try {
            const response = await apiService.get('/api/dashboard/cfo-report', {
                responseType: 'blob',
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `CATA_CFO_Report_${new Date().toISOString().split('T')[0]}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading CFO report:', error);
            throw error;
        }
    }
}

export const dashboardService = new DashboardService();
export default DashboardService;
